import script from "./AppImageViewer.vue?vue&type=script&setup=true&lang=js"
export * from "./AppImageViewer.vue?vue&type=script&setup=true&lang=js"

import "./AppImageViewer.vue?vue&type=style&index=0&id=8b04a6a6&lang=scss&scoped=true"

import exportComponent from "/Users/chronosme/Domains/mathgs2.mu/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-8b04a6a6"]])

export default __exports__